import React from "react";
import PropTypes from "prop-types";

const Loading = props => {
  const { bg, blocking, text } = props;
  const styles = {
    background: bg
  };
  if (blocking) {
    styles.pointerEvents = "auto";
  }
  return (
    <div className="loading" style={styles}>
      <div className="loading__circles">
        <div className="loading__circle-1" />
        <div className="loading__circle-2" />
      </div>
      {text && <p>{text}</p>}
    </div>
  );
};

Loading.propTypes = {
  bg: PropTypes.string,
  blocking: PropTypes.bool,
  text: PropTypes.string
};

Loading.defaultProps = {
  bg: null,
  blocking: true,
  text: null
};

export default Loading;
